/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketItemShopListListData model module.
 * @module model/MarketItemShopListListData
 * @version 1.0
 */
class MarketItemShopListListData {
    /**
     * Constructs a new <code>MarketItemShopListListData</code>.
     * @alias module:model/MarketItemShopListListData
     */
    constructor() { 
        
        MarketItemShopListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MarketItemShopListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketItemShopListListData} obj Optional instance to populate.
     * @return {module:model/MarketItemShopListListData} The populated <code>MarketItemShopListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketItemShopListListData();

            if (data.hasOwnProperty('productNo')) {
                obj['productNo'] = ApiClient.convertToType(data['productNo'], 'Number');
            }
            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('priceType')) {
                obj['priceType'] = ApiClient.convertToType(data['priceType'], 'Number');
            }
            if (data.hasOwnProperty('initPrice')) {
                obj['initPrice'] = ApiClient.convertToType(data['initPrice'], 'Number');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('limitType')) {
                obj['limitType'] = ApiClient.convertToType(data['limitType'], 'Number');
            }
            if (data.hasOwnProperty('purchaseLimit')) {
                obj['purchaseLimit'] = ApiClient.convertToType(data['purchaseLimit'], 'Number');
            }
            if (data.hasOwnProperty('saleLimit')) {
                obj['saleLimit'] = ApiClient.convertToType(data['saleLimit'], 'Number');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketItemShopListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketItemShopListListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} productNo
 */
MarketItemShopListListData.prototype['productNo'] = undefined;

/**
 * @member {Number} category
 */
MarketItemShopListListData.prototype['category'] = undefined;

/**
 * @member {Number} itemId
 */
MarketItemShopListListData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemCount
 */
MarketItemShopListListData.prototype['itemCount'] = undefined;

/**
 * @member {Number} priceType
 */
MarketItemShopListListData.prototype['priceType'] = undefined;

/**
 * @member {Number} initPrice
 */
MarketItemShopListListData.prototype['initPrice'] = undefined;

/**
 * @member {Number} price
 */
MarketItemShopListListData.prototype['price'] = undefined;

/**
 * @member {Number} limitType
 */
MarketItemShopListListData.prototype['limitType'] = undefined;

/**
 * @member {Number} purchaseLimit
 */
MarketItemShopListListData.prototype['purchaseLimit'] = undefined;

/**
 * @member {Number} saleLimit
 */
MarketItemShopListListData.prototype['saleLimit'] = undefined;

/**
 * @member {Date} startedAt
 */
MarketItemShopListListData.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
MarketItemShopListListData.prototype['endedAt'] = undefined;

/**
 * @member {Number} sort
 */
MarketItemShopListListData.prototype['sort'] = undefined;

/**
 * @member {Number} status
 */
MarketItemShopListListData.prototype['status'] = undefined;

/**
 * @member {Date} createdAt
 */
MarketItemShopListListData.prototype['createdAt'] = undefined;






export default MarketItemShopListListData;

